import { render, staticRenderFns } from "./company.main.vue?vue&type=template&id=b466b41e&scoped=true&"
import script from "./company.main.vue?vue&type=script&lang=js&"
export * from "./company.main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b466b41e",
  null
  
)

export default component.exports